import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'helpers/no_conflict_lodash';

import { Table } from 'react-bootstrap';
import RecordRow from './record_row';
import { getCurrentStep } from '../store/record_table_ui_selectors';
import { getHeaders, getRecords, getRecordIds } from '../store/run_records_selectors';

export function ScrollableRecordsTable({
  currentStep,
  headers,
  recordIds,
  records,
}) {
  const renderRecords = () => {
    return recordIds.map(id => <RecordRow key={id} record={records[id]}/>);
  };

  const renderHeaders = () => {
    return headers.map(header => <th className="table-cell" key={header}>{_.startCase(header)}</th>);
  };

  return (
    <div className="scrollable-table-container table-scroll-wrapper scroll-right-shadow scroll-left-shadow">
      <div className="table-scroll">
        <Table className="records-table mb-0">
          <thead className="records-header">
            <tr>
              {currentStep === 'preview' && <th className="table-cell">Action</th>}
              {renderHeaders()}
            </tr>
          </thead>
          <tbody className="records-body">
            {renderRecords()}
          </tbody>
        </Table>
      </div>
    </div>
  );
}

ScrollableRecordsTable.propTypes = {
  currentStep: PropTypes.string.isRequired,
  headers: PropTypes.array.isRequired,
  recordIds: PropTypes.array.isRequired,
  records: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  currentStep: getCurrentStep(state),
  headers: getHeaders(state),
  records: getRecords(state),
  recordIds: getRecordIds(state)
});

export default connect(mapStateToProps)(ScrollableRecordsTable);
